export isHeicFile = (file) ->
  file.type == 'image/heic' ||
  file.type == 'image/heif' ||
  file.name.toLowerCase().match(/\.hei[cf]$/)

